import _constant from 'lodash/constant';
import _isFunction from 'lodash/isFunction';
import _forEachRight from 'lodash/forEachRight';
import _partial from 'lodash/partial';
import _mapValues from 'lodash/mapValues';
import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _reduce from 'lodash/reduce';
import _range from 'lodash/range';
import _isString from 'lodash/isString';
import _merge from 'lodash/merge';
import _isEmpty from 'lodash/isEmpty';
import { CALL_API } from 'redux-api-middleware-fixed';
import { permissions, util } from 'veritone-functional-permissions';
import _noop from 'lodash/noop';
import { login } from 'veritone-oauth-helpers';
import { eventChannel, END } from 'redux-saga';
import { call, put, takeLatest, fork, all, take, takeEvery, race } from 'redux-saga/effects';
import _pickBy from 'lodash/pickBy';
import _keyBy from 'lodash/keyBy';
import _omit from 'lodash/omit';
import React, { Children, Component } from 'react';
import PropTypes, { string, func, objectOf, any } from 'prop-types';
import { connect } from 'react-redux';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

/*
BASIC USAGE:

import {
  WAIT_FOR_ACTION,
  ERROR_ACTION,
  CALLBACK_ARGUMENT,
  CALLBACK_ERROR_ARGUMENT
} from here;
store.dispatch({
  type: 'todos/get',
  [ WAIT_FOR_ACTION ]: 'todos/get/success', // Specify which action we are waiting for
  [ ERROR_ACTION ]: 'todos/get/failed', // Optional
  [ CALLBACK_ARGUMENT ]: action => action.customData, // Optional
  [ CALLBACK_ERROR_ARGUMENT ]: action => action.customError, // Optional
})
.then( payload => console.log('Todos got!') )
.catch( error => console.error('Failed!' + error.message) );
*/

// From documentation, needed for integrating with redux
const fsaCompliantArgumentCb = action => {
  return action.payload || action.data || {};
};
const fsaCompliantErrorArgumentCb = action => {
  return action.error || action.err || new Error('action.error not specified.');
};
// Add symbols to actions to activate promise return
// symbols don't show as normal keys, won't break actions
const WAIT_FOR_ACTION = Symbol('WAIT_FOR_ACTION');
const ERROR_ACTION = Symbol('ERROR_ACTION');
const CALLBACK_ARGUMENT = Symbol('CALLBACK_ARGUMENT');
const CALLBACK_ERROR_ARGUMENT = Symbol('ERROR_CALLBACK_ARGUMENT');

function promiseMiddleware() {
  let pendingActionList = [];

  const middleware = store => {
    return function (next) {
      return function (action) {
        const successAction = action[WAIT_FOR_ACTION];
        const errorAction = action[ERROR_ACTION];
        const newPendingActionInfo = {};

        // loop through list, see if there are any pending
        // promise callbacks by comparing types
        _forEachRight(pendingActionList, pendingActionInfo => {
          if (pendingActionInfo.isSuccessAction(action)) {
            pendingActionInfo.resolveCallback(pendingActionInfo.successArgumentCb(action));
            pendingActionList.splice(pendingActionList.indexOf(pendingActionInfo), 1);
          } else if (pendingActionInfo.isErrorAction(action)) {
            pendingActionInfo.rejectCallback(pendingActionInfo.errorArgumentCb(action));
            pendingActionList.splice(pendingActionList.indexOf(pendingActionInfo), 1);
          }
        });

        // If new action doesn't contain the symbol then we
        // are done
        if (!action[WAIT_FOR_ACTION]) {
          return next(action);
        }

        // These are the comparison function
        newPendingActionInfo.isSuccessAction = _isFunction(successAction) ? successAction : action => action.type === successAction;
        if (errorAction) {
          newPendingActionInfo.isErrorAction = _isFunction(errorAction) ? errorAction : action => action.type === errorAction;
        } else {
          newPendingActionInfo.isErrorAction = _constant(false);
        }

        // If you need to change which action info to push into the
        // promise callbacks, you can change them here
        newPendingActionInfo.successArgumentCb = action[CALLBACK_ARGUMENT] || fsaCompliantArgumentCb;
        newPendingActionInfo.errorArgumentCb = action[CALLBACK_ERROR_ARGUMENT] || fsaCompliantErrorArgumentCb;

        // Setting up promise to be called when action types match
        const promise = new Promise(function (resolve, reject) {
          newPendingActionInfo.resolveCallback = resolve;
          newPendingActionInfo.rejectCallback = reject;
        });

        pendingActionList.push(newPendingActionInfo);
        // Move on, but return a promise for dispatch
        next(action);
        return promise;
      };
    };
  };
  return middleware;
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};













var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

function reduceReducers(...reducers) {
  return (state, action) => {
    let isInitial = !state;
    return reducers.reduce((newState, reducer) => {
      if (isInitial) {
        return _extends({}, newState, reducer(undefined, action));
      } else {
        return reducer(newState, action);
      }
    }, _extends({}, state));
  };
}

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return `${s4()}-${s4()}-${s4()}`;
}

const fetchingStatus = {
  fetching: 'FETCHING',
  failure: 'FAILURE',
  success: 'SUCCESS',
  default: 'DEFAULT' // no action yet taken
};

// Creates a reducer and selectors that track the loading state for any api call.
// Designed to be used with callGraphQLApi.

// Use (in a module):

// const {
//   reducer: testReducer,
//   selectors: {
//     fetchingStatus: testFetchingStatus,
//     fetchingFailureMessage: testFetchingFailureMessage
//   }
// } = handleApiCall({
//   types: [GET_TEST, GET_TEST_SUCCESS, GET_TEST_FAILURE],
//   stateSelector: state => state.myModule
// });

// export default reduceReducers(
//   testReducer,
//   createReducer(defaultState, {
//     // ...other main reducer stuff
//     [GET_TEST_SUCCESS](state, action) {
//       // handleApiCall doesn't store the resource for you; it only tracks loading
//       // states
//       return {
//         ...state,
//         test: action.payload
//       }
//     }
//   })
// )

// export { testFetchingStatus, testFetchingFailureMessage }

// There are two options for handling multiple in-flight requests for the same
// resource:

// 1. If a `requestId` is passed to the callGraphQLApi call, that specific request
// (and any others that are given different requestIds) can be tracked individually
// by passing that requestId back to the selectors.

// 2. If no explicit `requestId` is given, only the "latest" call for a given
// resource is tracked. New calls will supersede old ones; old calls will
// still resolve normally, but fetchingStatus() etc will refer to the latest call.

// see tests for examples

function makeApiCallReducer(key, [requestType, successType, failureType]) {
  const defaultState = {
    fetchingStatusByRequestId: {},
    fetchingFailureMessagesByRequestId: {},
    activeRequestId: null
  };

  const apiCallReducer = createReducer(defaultState, {
    [requestType](state, {
      meta: {
        _internalRequestId
        // _shouldTrackRequestsIndividually = false
      } = {}
    }) {
      return {
        fetchingStatusByRequestId: _extends({}, state.fetchingStatusByRequestId, {
          [_internalRequestId]: fetchingStatus.fetching
        }),
        fetchingFailureMessagesByRequestId: _extends({}, state.fetchingFailureMessagesByRequestId, {
          [_internalRequestId]: ''
        }),
        activeRequestId: _internalRequestId
      };
    },

    [successType](state, {
      meta: {
        _internalRequestId,
        _shouldTrackRequestsIndividually = false
      } = {}
    }) {
      if (!_shouldTrackRequestsIndividually && _internalRequestId !== state.activeRequestId) {
        // ignore calls that have been superseded if not tracking individually
        return state;
      }

      return {
        fetchingStatusByRequestId: _extends({}, state.fetchingStatusByRequestId, {
          [_internalRequestId]: fetchingStatus.success
        }),
        fetchingFailureMessagesByRequestId: _extends({}, state.fetchingFailureMessagesByRequestId, {
          [_internalRequestId]: ''
        }),
        // don't clear active request -- we need it to find the "last" request
        activeRequestId: state.activeRequestId
      };
    },

    [failureType](state, {
      payload,
      meta: {
        _internalRequestId,
        _shouldTrackRequestsIndividually = false
      } = {}
    }) {
      if (!_shouldTrackRequestsIndividually && _internalRequestId !== state.activeRequestId) {
        // ignore calls that have been superseded if not tracking individually
        return state;
      }

      return {
        fetchingStatusByRequestId: _extends({}, state.fetchingStatusByRequestId, {
          [_internalRequestId]: fetchingStatus.failure
        }),
        fetchingFailureMessagesByRequestId: _extends({}, state.fetchingFailureMessagesByRequestId, {
          [_internalRequestId]: payload
        }),
        // don't clear active request -- we need it to find the "last" request
        activeRequestId: state.activeRequestId
      };
    }
  });

  return (state = {}, action) => {
    let baseState = state.apiCallHandlers ? state : { apiCallHandlers: { [key]: defaultState } };

    return _extends({}, state, {
      apiCallHandlers: _extends({}, baseState.apiCallHandlers, {
        [key]: apiCallReducer(baseState.apiCallHandlers[key], action)
      })
    });
  };
}

const selectors = {
  fetchingStatus(key, stateSelector, state, optionalRequestId) {
    const requestId = optionalRequestId || stateSelector(state).apiCallHandlers[key].activeRequestId;

    return _get(stateSelector(state).apiCallHandlers, [key, 'fetchingStatusByRequestId', requestId], fetchingStatus.default);
  },

  fetchingStatusByRequestId(key, stateSelector, state) {
    return _get(stateSelector(state).apiCallHandlers, [key, 'fetchingStatusByRequestId']);
  },

  fetchingFailureMessage(key, stateSelector, state, optionalRequestId) {
    const requestId = optionalRequestId || stateSelector(state).apiCallHandlers[key].activeRequestId;

    return _get(selectors.fetchingFailureMessagesByRequestId(key, stateSelector, state), requestId, '');
  },

  fetchingFailureMessagesByRequestId(key, stateSelector, state) {
    return _get(stateSelector(state).apiCallHandlers, [key, 'fetchingFailureMessagesByRequestId'], {});
  }
};
const defaultStateSelector = s => s;
const makeSelectors = (key, stateSelector = defaultStateSelector) => _mapValues(selectors, func$$1 => _partial(func$$1, key, stateSelector));

function handleApiCall({
  types: [requestType, successType, failureType],
  stateSelector = defaultStateSelector
}) {
  const key = guid();

  return {
    reducer: makeApiCallReducer(key, [requestType, successType, failureType]),
    selectors: makeSelectors(key, stateSelector),
    _key: key
  };
}

const promiseMiddleware$1 = {
  main: promiseMiddleware,
  WAIT_FOR_ACTION,
  ERROR_ACTION,
  CALLBACK_ARGUMENT,
  CALLBACK_ERROR_ARGUMENT
};

// Example usage:
// const reducer = reduceReducers(
//   paginate({
//     types: [LIST, LIST_SUCCESS, LIST_FAILURE],
//     key: 'own-engines',
//     filter: (action) => action.meta.type === 'own'
//   }),
//
//   paginate({
//     types: [LIST, LIST_SUCCESS, LIST_FAILURE],
//     key: 'other-engines',
//     filter: (action) => action.meta.type === 'other'
//   }),
//
//   createReducer(defaultState, {
//     [DELETE](state, action) {
//
//     }
//   })
// );

// based on
// https://github.com/reactjs/redux/blob/master/examples/real-world/src/reducers/paginate.js
function paginate({
  types,
  invalidateOnTypes = [], // invalidate pagination if we see this
  // todo: invalidationFilter?
  key = 'default',
  // allow a single paginator to manage pagination data for multiple similar responses.
  // ie. LIST_BUILDS has an engineId param, but we can't create a separate paginator
  // for each engine, so in the LIST_BUILDS paginator we keyBy: 'engineId'.

  // engineId data is expected to live at action.meta[engineId].

  // if keyBy is specified, `key` is ignored. In this example to select from a keyBy'd
  // reducer, use ie makeSelectors('engineId1'), makeSelectors('engineId2')

  // keyBy can also be a function, receiving (localState, action.meta), to
  // paginate on other state in the paginated store
  keyBy = null,
  // allow the same actions to be used for multiple pagination types by filtering
  // on something else in the action: (action) => bool
  filter = _constant(true),
  idAttribute = 'id',
  selectResponseResults = action => _get(action.payload, 'data.results.records', action.payload.results),
  selectResponseTotal = action => _get(action.payload, 'data.totalResults.count', action.payload.totalResults)
}) {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.');
  }

  if (!types.every(_isString)) {
    throw new Error('Expected types to be strings.');
  }

  if (!_isString(key)) {
    throw new Error('Expected key to be a string.');
  }

  if (!_isFunction(filter)) {
    throw new Error('Expected filter to be a function.');
  }

  if (keyBy && !(_isString(keyBy) || _isFunction(keyBy))) {
    throw new Error('Expected keyBy to be a string or function.');
  }

  const [requestType, successType, failureType] = types;

  let defaultState = {
    status: fetchingStatus.default,
    // { 5: 'myEngineId' } where 5 is index of myEngineId in overall server data set
    // (object because sparse arrays don't work well)
    idsByPaginationOrder: {},
    // which IDs are currently fetching (based on offset/limit specified)
    fetchingEntities: [],
    failedFetchingEntities: [],
    totalEntities: 0,
    // requestId of active request (so new requests can supersede old ones)
    activeRequestId: null
  };

  const updatePagination = createReducer(defaultState, _extends({
    [requestType](state, action) {
      if (!filter(action)) {
        return state;
      }

      const requestSuccessState = _extends({}, state, {
        status: fetchingStatus.fetching,
        fetchingEntities: _range(action.meta.offset, action.meta.offset + action.meta.limit),
        failedFetchingEntities: [],
        activeRequestId: action.meta.requestId
      });

      return action.error ? // handle requestError ie. offline
      this[failureType](_extends({}, state, _pick(requestSuccessState, ['fetchingEntities', 'activeRequestId'])), action) : requestSuccessState;
    },

    [successType](state, action) {
      if (!filter(action)) {
        return state;
      }

      const { offset, requestId } = action.meta;

      if (requestId !== state.activeRequestId) {
        // ignore calls that have been superseded
        return state;
      }

      const totalEntities = selectResponseTotal(action) || 0;
      const totalDidChange = state.totalEntities !== totalEntities;

      return _extends({}, state, {
        status: fetchingStatus.success,

        idsByPaginationOrder: _reduce(selectResponseResults(action), (order, entity, i) => {
          order[i + offset] = entity[idAttribute];
          return order;
          // drop unreliable pagination data if total changes
        }, totalDidChange ? {} : _extends({}, state.idsByPaginationOrder)),

        fetchingEntities: [],
        failedFetchingEntities: [],
        totalEntities: totalEntities,
        activeRequestId: null
      });
    },

    [failureType](state, action) {
      if (!filter(action)) {
        return state;
      }

      const { requestId } = action.meta;

      if (requestId !== state.activeRequestId) {
        // ignore calls that have been superseded
        return state;
      }

      return _extends({}, state, {
        status: fetchingStatus.failure,
        fetchingEntities: [],
        failedFetchingEntities: [...state.failedFetchingEntities, ...state.fetchingEntities],
        activeRequestId: null
      });
    },

    [CLEAR_PAGINATION](state, action) {
      // fixme-- more granular clearing by key?
      // if (action.payload !== key) {
      //   return state;
      // }

      return _extends({}, state, {
        // does not cancel in-flight requests
        idsByPaginationOrder: {}
      });
    }

  }, invalidateOnTypes.reduce((res, type) => {
    res[type] = function (...args) {
      return this[CLEAR_PAGINATION](...args);
    };
    return res;
  }, {})));

  return (state = {}, action) => {
    let baseKey = keyBy ? _isString(keyBy) ? _get(action, ['meta', keyBy], 'init-ignore-this') // fixme?
    : keyBy(state, _get(action, 'meta')) : key;

    let baseState = state.pagination ? state : {
      pagination: { [baseKey]: defaultState }
    };

    return _extends({}, state, {
      pagination: _extends({}, baseState.pagination, {
        [baseKey]: updatePagination(baseState.pagination[baseKey], action)
      })
    });
  };
}

const makeSelectors$1 = (key = 'default') => ({
  selectFetchingStatus: localState => _get(localState.pagination, [key, 'status']),

  selectPaginationOrder: localState => _get(localState.pagination, [key, 'idsByPaginationOrder']),

  selectFetchingEntities: localState => _get(localState.pagination, [key, 'fetchingEntities']),

  selectFailedFetchingEntities: localState => _get(localState.pagination, [key, 'failedFetchingEntities']),

  selectTotalEntities: localState => _get(localState.pagination, [key, 'totalEntities'])
});

const CLEAR_PAGINATION = 'vtn/pagination/CLEAR_PAGINATION';
function clearPagination(key = 'default') {
  return {
    type: CLEAR_PAGINATION,
    payload: key
  };
}



var paginate$1 = Object.freeze({
	default: paginate,
	makeSelectors: makeSelectors$1,
	clearPagination: clearPagination
});

const FETCH_USER = 'vtn/user/FETCH_USER';
const FETCH_USER_SUCCESS = 'vtn/user/FETCH_USER_SUCCESS';
const FETCH_USER_FAILURE = 'vtn/user/FETCH_USER_FAILURE';

const LOGIN = 'vtn/user/LOGIN';
const LOGIN_SUCCESS = 'vtn/user/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'vtn/user/LOGIN_FAILURE';

const LOGOUT = 'vtn/user/LOGOUT';
const LOGOUT_SUCCESS = 'vtn/user/LOGOUT_SUCCESS';
const LOGOUT_FAILURE = 'vtn/user/LOGOUT_FAILURE';

const REFRESH_TOKEN = 'vtn/user/REFRESH_TOKEN';
const REFRESH_TOKEN_SUCCESS = 'vtn/user/REFRESH_TOKEN_SUCCESS';
const REFRESH_TOKEN_FAILURE = 'vtn/user/REFRESH_TOKEN_FAILURE';

const FETCH_USER_APPLICATIONS = 'vtn/user/FETCH_USER_APPLICATIONS';
const FETCH_USER_APPLICATIONS_SUCCESS = 'vtn/user/FETCH_USER_APPLICATIONS_SUCCESS';
const FETCH_USER_APPLICATIONS_FAILURE = 'vtn/user/FETCH_USER_APPLICATIONS_FAILURE';

const RESET_USER_PASSWORD = 'vtn/user/RESET_USER_PASSWORD';
const RESET_USER_PASSWORD_SUCCESS = 'vtn/user/RESET_USER_PASSWORD_SUCCESS';
const RESET_USER_PASSWORD_FAILURE = 'vtn/user/RESET_USER_PASSWORD_FAILURE';

const UPDATE_CURRENT_USER_PROFILE = 'vtn/user/UPDATE_CURRENT_USER_PROFILE';
const UPDATE_CURRENT_USER_PROFILE_SUCCESS = 'vtn/user/UPDATE_CURRENT_USER_PROFILE_SUCCESS';
const UPDATE_CURRENT_USER_PROFILE_FAILURE = 'vtn/user/UPDATE_CURRENT_USER_PROFILE_FAILURE';

var userConstants = Object.freeze({
	FETCH_USER: FETCH_USER,
	FETCH_USER_SUCCESS: FETCH_USER_SUCCESS,
	FETCH_USER_FAILURE: FETCH_USER_FAILURE,
	LOGIN: LOGIN,
	LOGIN_SUCCESS: LOGIN_SUCCESS,
	LOGIN_FAILURE: LOGIN_FAILURE,
	LOGOUT: LOGOUT,
	LOGOUT_SUCCESS: LOGOUT_SUCCESS,
	LOGOUT_FAILURE: LOGOUT_FAILURE,
	REFRESH_TOKEN: REFRESH_TOKEN,
	REFRESH_TOKEN_SUCCESS: REFRESH_TOKEN_SUCCESS,
	REFRESH_TOKEN_FAILURE: REFRESH_TOKEN_FAILURE,
	FETCH_USER_APPLICATIONS: FETCH_USER_APPLICATIONS,
	FETCH_USER_APPLICATIONS_SUCCESS: FETCH_USER_APPLICATIONS_SUCCESS,
	FETCH_USER_APPLICATIONS_FAILURE: FETCH_USER_APPLICATIONS_FAILURE,
	RESET_USER_PASSWORD: RESET_USER_PASSWORD,
	RESET_USER_PASSWORD_SUCCESS: RESET_USER_PASSWORD_SUCCESS,
	RESET_USER_PASSWORD_FAILURE: RESET_USER_PASSWORD_FAILURE,
	UPDATE_CURRENT_USER_PROFILE: UPDATE_CURRENT_USER_PROFILE,
	UPDATE_CURRENT_USER_PROFILE_SUCCESS: UPDATE_CURRENT_USER_PROFILE_SUCCESS,
	UPDATE_CURRENT_USER_PROFILE_FAILURE: UPDATE_CURRENT_USER_PROFILE_FAILURE
});

const REQUEST_OAUTH_GRANT = 'REQUEST_OAUTH_GRANT';
const REQUEST_OAUTH_GRANT_IMPLICIT = 'REQUEST_OAUTH_GRANT_IMPLICIT';
const OAUTH_GRANT_FLOW_FAILED = 'OAUTH_GRANT_FLOW_FAILED';
const OAUTH_GRANT_FLOW_SUCCESS = 'OAUTH_GRANT_FLOW_SUCCESS';
const SET_SESSION_TOKEN = 'vtn/user/SET_SESSION_TOKEN';
const SET_OAUTH_TOKEN = 'vtn/user/SET_OAUTH_TOKEN';
const CHECK_AUTH_NO_TOKEN = 'vtn/user/CHECK_AUTH_NO_TOKEN';

var authConstants = Object.freeze({
	REQUEST_OAUTH_GRANT: REQUEST_OAUTH_GRANT,
	REQUEST_OAUTH_GRANT_IMPLICIT: REQUEST_OAUTH_GRANT_IMPLICIT,
	OAUTH_GRANT_FLOW_FAILED: OAUTH_GRANT_FLOW_FAILED,
	OAUTH_GRANT_FLOW_SUCCESS: OAUTH_GRANT_FLOW_SUCCESS,
	SET_SESSION_TOKEN: SET_SESSION_TOKEN,
	SET_OAUTH_TOKEN: SET_OAUTH_TOKEN,
	CHECK_AUTH_NO_TOKEN: CHECK_AUTH_NO_TOKEN
});

const namespace = 'auth';

const defaultState = {
  OAuthToken: null,
  OAuthErrorCode: null,
  OAuthErrorDescription: null,
  sessionToken: null,
  userId: null
};

const reducer = createReducer(defaultState, {
  [OAUTH_GRANT_FLOW_SUCCESS](state, {
    payload: { OAuthToken }
  }) {
    return _extends({}, state, {
      OAuthToken,
      OAuthErrorCode: null,
      OAuthErrorDescription: null
    });
  },

  [OAUTH_GRANT_FLOW_FAILED](state, {
    payload: { error, errorDescription }
  }) {
    return _extends({}, state, {
      OAuthErrorCode: error,
      OAuthErrorDescription: errorDescription
    });
  },

  [LOGIN_SUCCESS](state, action) {
    return _extends({}, state, {
      sessionToken: action.payload.token
    });
  },

  [FETCH_USER_SUCCESS](state, action) {
    return _extends({}, state, {
      sessionToken: action.payload.token,
      userId: action.payload.userId
    });
  },

  [REFRESH_TOKEN_SUCCESS](state, action) {
    return _extends({}, state, {
      sessionToken: action.payload.token
    });
  },

  [SET_SESSION_TOKEN](state, { payload }) {
    return _extends({}, state, {
      sessionToken: payload
    });
  },

  [SET_OAUTH_TOKEN](state, { payload }) {
    return _extends({}, state, {
      OAuthToken: payload,
      OAuthErrorCode: null,
      OAuthErrorDescription: null
    });
  }
});

function local(state) {
  return state[namespace];
}

function setSessionToken(token) {
  // put a session token into state. This is temporary -- if the user
  // is fetched, it will be replaced with the one from the server. Should be
  // used for initial fetchUser calls when the token is already known.
  return {
    type: SET_SESSION_TOKEN,
    payload: token
  };
}

function setOAuthToken(token) {
  // put an OAuth token into state. For when an OAuthToken is provided
  // outside the OAUTH_GRANT flow
  return {
    type: SET_OAUTH_TOKEN,
    payload: token
  };
}

function checkAuthNoToken() {
  return {
    type: CHECK_AUTH_NO_TOKEN
  };
}

function requestOAuthGrant({ OAuthURI, onSuccess, onFailure }) {
  return {
    type: REQUEST_OAUTH_GRANT,
    payload: { OAuthURI, onSuccess, onFailure }
  };
}

function requestOAuthGrantImplicit({
  OAuthURI,
  responseType = 'token',
  scope = 'all',
  clientId,
  redirectUri,
  onSuccess,
  onFailure
}) {
  return {
    type: REQUEST_OAUTH_GRANT_IMPLICIT,
    payload: {
      OAuthURI,
      responseType,
      scope,
      clientId,
      redirectUri,
      onSuccess,
      onFailure
    }
  };
}

function OAuthGrantSuccess({ OAuthToken }) {
  return {
    type: OAUTH_GRANT_FLOW_SUCCESS,
    payload: { OAuthToken }
  };
}

function OAuthGrantFailure({ error, errorDescription }) {
  return {
    type: OAUTH_GRANT_FLOW_FAILED,
    payload: { error, errorDescription },
    error: true
  };
}

function selectSessionToken(state) {
  return local(state).sessionToken;
}

function selectOAuthToken(state) {
  return local(state).OAuthToken;
}

function selectOAuthError(state) {
  return {
    code: local(state).OAuthErrorCode,
    description: local(state).OAuthErrorDescription
  };
}

/**
 * Selects user id
 * @param state
 * @returns {null}
 */
const selectUserId = state => local(state).userId;



var authModule = Object.freeze({
	namespace: namespace,
	default: reducer,
	setSessionToken: setSessionToken,
	setOAuthToken: setOAuthToken,
	checkAuthNoToken: checkAuthNoToken,
	requestOAuthGrant: requestOAuthGrant,
	requestOAuthGrantImplicit: requestOAuthGrantImplicit,
	OAuthGrantSuccess: OAuthGrantSuccess,
	OAuthGrantFailure: OAuthGrantFailure,
	selectSessionToken: selectSessionToken,
	selectOAuthToken: selectOAuthToken,
	selectOAuthError: selectOAuthError,
	selectUserId: selectUserId
});

// reducer supporting shared-components/withUIState decorator
// import { } from 'lodash';

const namespace$1 = 'ui-state';

const SET_STATE = 'vtn/ui-state/SET_STATE';
const CLEAR_STATE = 'vtn/ui-state/CLEAR_STATE';

const defaultState$1 = {};

const reducer$1 = createReducer(defaultState$1, {
  [SET_STATE](state, action) {
    return _extends({}, state, {
      [action.meta.key]: _extends({}, state[action.meta.key], action.payload)
    });
  },

  [CLEAR_STATE](state, action) {
    let newState = _extends({}, state);
    delete newState[action.meta.key];

    return newState;
  }
});

function local$1(state) {
  return state[namespace$1];
}

function setStateForKey(key, mergeState) {
  return {
    type: SET_STATE,
    meta: {
      key
    },
    payload: _extends({}, mergeState)
  };
}

function getStateForKey(state, key) {
  return local$1(state)[key];
}

function clearStateForKey(key) {
  return {
    type: CLEAR_STATE,
    meta: {
      key
    }
  };
}



var uiStateModule = Object.freeze({
	namespace: namespace$1,
	SET_STATE: SET_STATE,
	CLEAR_STATE: CLEAR_STATE,
	default: reducer$1,
	setStateForKey: setStateForKey,
	getStateForKey: getStateForKey,
	clearStateForKey: clearStateForKey
});

const namespace$2 = 'config';
const SET_CONFIG = 'vtn/config/SET_CONFIG';
const defaultState$2 = {};

const reducer$2 = createReducer(defaultState$2, {
  [SET_CONFIG](state, action) {
    return _extends({}, state, action.payload);
  }
});

function local$2(state) {
  return state[namespace$2];
}

function setConfig(obj = {}) {
  return {
    type: SET_CONFIG,
    payload: obj
  };
}

function getConfig(state) {
  return local$2(state);
}

/**
 * Selects application id. This should be passed down from the primary app
 * @param state
 * @returns {*}
 */
const selectApplicationId = state => getConfig(state).applicationId;



var configModule = Object.freeze({
	namespace: namespace$2,
	SET_CONFIG: SET_CONFIG,
	default: reducer$2,
	setConfig: setConfig,
	getConfig: getConfig,
	selectApplicationId: selectApplicationId
});

async function callGraphQLApi({
  actionTypes: [requestType, successType, failureType],
  extraHeaders,
  query,
  variables,
  operationName,
  bailout = _constant(false),
  dispatch,
  getState,
  // optional requestId which can be given to the selectors generated by
  // handleApiCall to track state of an individual request (by default only the
  // latest request is tracked)
  requestId
}) {
  if (!_isFunction(dispatch) || !_isFunction(getState)) {
    throw new Error('callGraphQLApi requires dispatch and getState functions');
  }

  const state = getState();
  const config$$1 = getConfig(state);
  const endpoint = `${config$$1.apiRoot}/${config$$1.graphQLEndpoint}`;
  const token = selectOAuthToken(state) || selectSessionToken(state);

  const shouldBail = bailout(state);
  if (shouldBail) {
    return;
  }

  let _extraHeaders = extraHeaders;
  if (!Object.keys(extraHeaders || {}).length) {
    _extraHeaders = getExtraHeaders$1(state);
  }

  // attach an ID so the handleApiCall reducer can track this request across
  // its multiple actions
  const _internalRequestId = requestId || guid();

  dispatch({
    type: requestType,
    meta: {
      variables,
      operationName,
      query,
      _internalRequestId,
      _shouldTrackRequestsIndividually: !!requestId
    }
  });

  let response;
  try {
    response = await fetchGraphQLApi({
      endpoint,
      query,
      variables,
      operationName,
      token,
      extraHeaders: _extraHeaders
    });
  } catch (e) {
    dispatch({
      type: failureType,
      error: true,
      payload: e,
      meta: {
        response,
        variables,
        operationName,
        query,
        _internalRequestId,
        _shouldTrackRequestsIndividually: !!requestId
      }
    });

    let error = new Error('API call failed');
    // wrap this single error for consistency with graphQL errors, which are always
    // wrapped.
    error.errors = [e];
    throw error;
  }

  if (response.errors && response.errors.length) {
    dispatch({
      type: failureType,
      error: true,
      payload: response.errors,
      meta: {
        response,
        variables,
        operationName,
        query,
        _internalRequestId,
        _shouldTrackRequestsIndividually: !!requestId
      }
    });

    let error = new Error('API response included errors');
    error.errors = response.errors;
    throw error;
  }

  dispatch({
    type: successType,
    payload: response.data,
    meta: {
      response,
      variables,
      operationName,
      query,
      _internalRequestId,
      _shouldTrackRequestsIndividually: !!requestId
    }
  });

  return response.data;
}

const namespace$3 = 'user';

const {
  reducer: resetUserPasswordReducer,
  selectors: {
    fetchingStatus: resetUserPasswordFetchingStatus,
    fetchingFailureMessage: resetUserPasswordFailureMessage
  }
} = handleApiCall({
  types: [RESET_USER_PASSWORD, RESET_USER_PASSWORD_SUCCESS, RESET_USER_PASSWORD_FAILURE]
});

const {
  reducer: updateCurrentUserProfileReducer,
  selectors: {
    fetchingStatus: updateCurrentUserProfileFetchingStatus,
    fetchingFailureMessage: updateCurrentUserProfileFailureMessage
  }
} = handleApiCall({
  types: [UPDATE_CURRENT_USER_PROFILE, UPDATE_CURRENT_USER_PROFILE_SUCCESS, UPDATE_CURRENT_USER_PROFILE_FAILURE]
});

const defaultState$3 = {
  user: {},

  isFetching: false,
  fetchingFailed: false,

  isLoggingIn: false,
  loginFailed: false,
  loginFailureMessage: null,

  isFetchingApplications: false,
  fetchApplicationsFailed: false,
  fetchApplicationsFailureMessage: null,
  enabledApps: []
};

const reducer$3 = reduceReducers(resetUserPasswordReducer, updateCurrentUserProfileReducer, createReducer(defaultState$3, {
  [FETCH_USER](state, action) {
    const requestSuccessState = _extends({}, state, {
      isFetching: true,
      fetchingFailed: false
    });

    return action.error ? // handle requestError ie. offline
    this[FETCH_USER_FAILURE](state, action) : requestSuccessState;
  },

  [FETCH_USER_SUCCESS](state, action) {
    return _extends({}, state, {
      isFetching: false,
      fetchingFailed: false,
      user: action.payload
    });
  },

  [FETCH_USER_FAILURE](state, action) {
    return _extends({}, state, {
      isFetching: false,
      fetchingFailed: true,
      user: {}
    });
  },

  [LOGIN](state, action) {
    const requestSuccessState = _extends({}, state, {
      isLoggingIn: true,
      loginFailed: false,
      loginFailureMessage: null
    });

    return action.error ? this[LOGIN_FAILURE](state, action) : requestSuccessState;
  },

  [LOGIN_SUCCESS](state, action) {
    return _extends({}, state, {
      isLoggingIn: false,
      loginFailed: false,
      user: action.payload,
      loginFailureMessage: null
    });
  },

  [LOGIN_FAILURE](state, action) {
    const statusErrors = {
      404: "Couldn't login, please double check your username and password.",
      default: "Couldn't login, please try again."
    };

    const failureMessage = action.payload.name === 'ApiError' ? statusErrors[action.payload.status] || statusErrors.default : action.payload.name === 'RequestError' ? 'There was an error while logging in, please try again.' : statusErrors.default;

    return _extends({}, state, {
      isLoggingIn: false,
      loginFailed: true,
      loginFailureMessage: failureMessage,
      user: {}
    });
  },

  [LOGOUT_SUCCESS](state) {
    return _extends({}, state, {
      user: {}
    });
  },

  [FETCH_USER_APPLICATIONS](state, action) {
    const requestSuccessState = _extends({}, state, {
      isFetchingApplications: true,
      fetchApplicationsFailed: false,
      fetchApplicationsFailureMessage: null,
      enabledApps: []
    });

    return action.error ? this[FETCH_USER_APPLICATIONS_FAILURE](state, action) : requestSuccessState;
  },

  [FETCH_USER_APPLICATIONS_SUCCESS](state, action) {
    return _extends({}, state, {
      isFetchingApplications: false,
      fetchApplicationsFailed: false,
      enabledApps: action.payload.results,
      fetchApplicationsFailureMessage: null
    });
  },

  [FETCH_USER_APPLICATIONS_FAILURE](state, action) {
    const statusErrors = {
      404: "Couldn't get application list.",
      default: "Couldn't get application list. Please login."
    };

    const failureMessage = action.payload.name === 'ApiError' ? statusErrors[action.payload.status] || statusErrors.default : action.payload.name === 'RequestError' ? 'There was an error when fetching application list, please try again.' : statusErrors.default;

    return _extends({}, state, {
      isFetchingApplications: false,
      fetchApplicationsFailed: true,
      fetchApplicationsFailureMessage: failureMessage,
      enabledApps: []
    });
  },

  [REFRESH_TOKEN_SUCCESS](state, action) {
    return _extends({}, state, {
      user: action.payload
    });
  },

  [UPDATE_CURRENT_USER_PROFILE_SUCCESS](state, {
    payload: {
      updateCurrentUser: { firstName, lastName, imageUrl: image }
    }
  }) {
    // fixme: for now, this has to paper over some differences between REST
    // and graphQL apis
    const newUserKvp = _merge({}, state.user.kvp, {
      firstName,
      lastName,
      image
    });

    return _extends({}, state, {
      user: _extends({}, state.user, {
        kvp: newUserKvp,
        signedImageUrl: image || state.user.signedImageUrl
      })
    });
  }
}));

function local$3(state) {
  return state[namespace$3];
}

function fetchUser() {
  return {
    [CALL_API]: {
      types: [FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURE],
      endpoint: state => `${getConfig(state).apiRoot}/v1/admin/current-user`,
      method: 'GET',
      headers: commonHeaders,
      credentials: getCredentialsMode()
    }
  };
}

function login$1({ userName, password }) {
  return {
    [CALL_API]: {
      types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE],
      endpoint: state => `${getConfig(state).apiRoot}/v1/admin/login`,
      method: 'POST',
      body: JSON.stringify({
        userName,
        password
      }),
      headers: commonHeaders,
      credentials: getCredentialsMode()
    }
  };
}

function logout() {
  return {
    [CALL_API]: {
      types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAILURE],
      endpoint: state =>
      // prettier-ignore
      `${getConfig(state).apiRoot}/v1/admin/token/${selectSessionToken(state)}/logout`,
      method: 'GET',
      headers: commonHeaders,
      credentials: getCredentialsMode()
    }
  };
}

function refreshApiToken() {
  return {
    [CALL_API]: {
      types: [REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAILURE],
      endpoint: state =>
      // prettier-ignore
      `${getConfig(state).apiRoot}/v1/admin/token/${selectSessionToken(state)}/refresh`,
      method: 'GET',
      headers: commonHeaders,
      credentials: getCredentialsMode()
    }
  };
}

function fetchEnabledApps() {
  return {
    [CALL_API]: {
      types: [FETCH_USER_APPLICATIONS, FETCH_USER_APPLICATIONS_SUCCESS, FETCH_USER_APPLICATIONS_FAILURE],
      endpoint: state => `${getConfig(state).apiRoot}/v1/admin/current-user/applications`,
      method: 'GET',
      headers: commonHeaders,
      credentials: getCredentialsMode()
    }
  };
}

const resetUserPassword = email => (dispatch, getState) => {
  const query = `
    mutation ($email: String!) {
      createPasswordResetRequest(input: { userName: $email }) {
        message
      }
    }
  `;

  const emailToReset = email || selectUser(getState()).email;

  return callGraphQLApi({
    actionTypes: [RESET_USER_PASSWORD, RESET_USER_PASSWORD_SUCCESS, RESET_USER_PASSWORD_FAILURE],
    query,
    variables: {
      email: emailToReset
    },
    dispatch,
    getState
  });
};

const updateCurrentUserProfile = vals => (dispatch, getState) => {
  const query = `
    mutation ($input: UpdateCurrentUser!){
      updateCurrentUser(input: $input) {
        firstName
        lastName
        imageUrl
      }
    }
  `;

  // when updating, update these in the query, too
  const acceptableVals = ['firstName', 'lastName', 'imageUrl'];

  return callGraphQLApi({
    actionTypes: [UPDATE_CURRENT_USER_PROFILE, UPDATE_CURRENT_USER_PROFILE_SUCCESS, UPDATE_CURRENT_USER_PROFILE_FAILURE],
    query,
    variables: {
      input: _pick(vals, acceptableVals)
    },
    dispatch,
    getState
  });
};

function isLoggingIn(state) {
  return local$3(state).isLoggingIn;
}

function loginFailed(state) {
  return local$3(state).loginFailed;
}

function loginFailureMessage(state) {
  return local$3(state).loginFailureMessage;
}

function isFetching(state) {
  return local$3(state).isFetching;
}

function fetchingFailed(state) {
  return local$3(state).fetchingFailed;
}

function selectUser(state) {
  return local$3(state).user;
}

function selectUserOrganizationId(state) {
  return _get(local$3(state).user, 'organization.organizationId');
}

function selectUserOrganizationKvp(state) {
  return _get(local$3(state).user, 'organization.kvp');
}

function enabledAppsFailedLoading(state) {
  return local$3(state).fetchApplicationsFailed;
}

function isFetchingApps(state) {
  return local$3(state).isFetchingApplications;
}

function enabledAppsFailureMessage(state) {
  return local$3(state).fetchApplicationsFailureMessage;
}

function selectEnabledApps(state) {
  // fixme: how should migrations work without the cookie in external apps?
  const apps = local$3(state).enabledApps;
  // let migrated = cookie.get('veritone-migrated-to-discovery') === 'true';

  return apps.map(app => {
    const migrations = {
      // advertiser: migrated ? 'Discovery' : 'Advertiser',
      // broadcaster: migrated ? 'Discovery' : 'Media'
    };

    return _extends({}, app, {
      applicationName: migrations[app.applicationName] || app.applicationName
    });
  }).filter(app => {
    if (app.applicationCheckPermissions === false) {
      return true;
    }

    const appAccessPermissionId = _get(permissions, [app.applicationKey, 'access']);

    return appAccessPermissionId && util.hasAccessTo(appAccessPermissionId, selectUser(state).permissionMasks);
  });
}

function userIsAuthenticated(state) {
  return !_isEmpty(local$3(state).user);
}

function hasFeature(state, featureName) {
  return _get(local$3(state), ['user', 'organization', 'kvp', 'features', featureName]) === 'enabled';
}



var userModule = Object.freeze({
	namespace: namespace$3,
	resetUserPasswordFetchingStatus: resetUserPasswordFetchingStatus,
	resetUserPasswordFailureMessage: resetUserPasswordFailureMessage,
	updateCurrentUserProfileFetchingStatus: updateCurrentUserProfileFetchingStatus,
	updateCurrentUserProfileFailureMessage: updateCurrentUserProfileFailureMessage,
	default: reducer$3,
	fetchUser: fetchUser,
	login: login$1,
	logout: logout,
	refreshApiToken: refreshApiToken,
	fetchEnabledApps: fetchEnabledApps,
	resetUserPassword: resetUserPassword,
	updateCurrentUserProfile: updateCurrentUserProfile,
	isLoggingIn: isLoggingIn,
	loginFailed: loginFailed,
	loginFailureMessage: loginFailureMessage,
	isFetching: isFetching,
	fetchingFailed: fetchingFailed,
	selectUser: selectUser,
	selectUserOrganizationId: selectUserOrganizationId,
	selectUserOrganizationKvp: selectUserOrganizationKvp,
	enabledAppsFailedLoading: enabledAppsFailedLoading,
	isFetchingApps: isFetchingApps,
	enabledAppsFailureMessage: enabledAppsFailureMessage,
	selectEnabledApps: selectEnabledApps,
	userIsAuthenticated: userIsAuthenticated,
	hasFeature: hasFeature
});

function* requestOAuthGrant$1({
  payload: { OAuthURI, onSuccess = _noop, onFailure = _noop }
}) {
  let token;

  try {
    let { OAuthToken } = yield call(login, OAuthURI);
    token = OAuthToken;
  } catch (e) {
    console.log('oauth flow error', e);
    yield put(OAuthGrantFailure(e));
    yield call(onFailure, e);
    return;
  }

  yield put(OAuthGrantSuccess({ OAuthToken: token }));
  yield call(onSuccess, { OAuthToken: token });
}

function* requestOAuthGrantImplicit$1({
  payload: {
    OAuthURI,
    responseType,
    clientId,
    redirectUri,
    scope,
    onSuccess = _noop,
    onFailure = _noop
  }
}) {
  const authWindow = yield call(window.open, `${OAuthURI}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`, '_auth', 'width=550px,height=650px');

  const windowEventChannel = eventChannel(emitter => {
    function handleEvent(e) {
      if (e.data.OAuthToken || e.data.error) {
        emitter({
          OAuthToken: e.data.OAuthToken,
          error: e.data.error,
          errorDescription: e.data.errorDescription
        });
        emitter(END);
      }
    }

    window.addEventListener('message', handleEvent, false);

    return () => {
      // unsubscribe
      window.removeEventListener('message', handleEvent);
    };
  });

  const { OAuthToken, error, errorDescription } = yield take(windowEventChannel);
  yield call([authWindow, authWindow.close]);

  if (OAuthToken) {
    yield put(OAuthGrantSuccess({ OAuthToken }));
    yield call(onSuccess, { OAuthToken });
  } else if (error) {
    yield put(OAuthGrantFailure({ error, errorDescription }));
    yield call(onFailure, error, errorDescription);
  }
}

function* watchOAuthGrantRequest() {
  yield all([takeLatest(REQUEST_OAUTH_GRANT, requestOAuthGrant$1), takeLatest(REQUEST_OAUTH_GRANT_IMPLICIT, requestOAuthGrantImplicit$1)]);
}

function* root() {
  yield all([fork(watchOAuthGrantRequest)]);
}

const namespace$4 = 'engine';

const FETCH_ENGINES = 'vtn/engine/FETCH_ENGINES';
const FETCH_ENGINES_SUCCESS = 'vtn/engine/FETCH_ENGINES_SUCCESS';
const FETCH_ENGINES_FAILURE = 'vtn/engine/FETCH_ENGINES_FAILURE';

const FETCH_ENGINE_CATEGORIES = 'vtn/engine/FETCH_ENGINE_CATEGORIES';
const FETCH_ENGINE_CATEGORIES_SUCCESS = 'vtn/engine/FETCH_ENGINE_CATEGORIES_SUCCESS';
const FETCH_ENGINE_CATEGORIES_FAILURE = 'vtn/engine/FETCH_ENGINES_CATEGORIES_FAILURE';

const defaultState$4 = {
  enginesById: {},
  isFetching: false,
  fetchingFailed: false,
  engineCategories: [],
  isFetchingCategories: false,
  fetchingCategoriesFailed: false
};

var engineReducer = createReducer(defaultState$4, {
  [FETCH_ENGINES](state, action) {
    return _extends({}, state, {
      isFetching: true,
      fetchingFailed: false
    });
  },
  [FETCH_ENGINES_SUCCESS](state, action) {
    return _extends({}, state, {
      isFetching: false,
      fetchingFailed: false,
      enginesById: _extends({}, state.enginesById, _keyBy(action.payload.results, 'id'))
    });
  },
  [FETCH_ENGINES_FAILURE](state, action) {
    return _extends({}, state, {
      isFetching: false,
      fetchingFailed: true
    });
  },
  [FETCH_ENGINE_CATEGORIES](state, action) {
    return _extends({}, state, {
      isFetchingCategories: true,
      fetchingCategoriesFailed: false
    });
  },
  [FETCH_ENGINE_CATEGORIES_SUCCESS](state, action) {
    return _extends({}, state, {
      isFetchingCategories: false,
      fetchingCategoriesFailed: false,
      engineCategories: [...action.payload.results.records]
    });
  },
  [FETCH_ENGINE_CATEGORIES_FAILURE](state, action) {
    return _extends({}, state, {
      isFetchingCategories: false,
      fetchingCategoriesFailed: true
    });
  }
});

function local$4(state) {
  return state[namespace$4];
}

function fetchEngines({ offset, limit, owned } = {}, searchQuery, filters = {}, builds = {}, id) {
  return async function action(dispatch, getState) {
    dispatch({ type: FETCH_ENGINES });

    const query = `
      ${engineFieldsFragment}
      query Engines(
        $name: String = ""
        $offset: Int
        $limit: Int
        $owned: Boolean
        $filter: EngineFilter
        $buildsOffset: Int
        $buildsLimit: Int
        $buildsStatusStr: [String]
        $buildsStatus: [BuildStatus!]
        $buildsId: ID
        $withBuilds: Boolean!
      ) {
        engines(
          name: $name
          offset: $offset
          limit: $limit
          owned: $owned
          filter: $filter
        ) {
          records {
            ...engineFields
            builds(
              offset: $buildsOffset
              limit: $buildsLimit
              status: $buildsStatusStr
              buildStatus: $buildsStatus
              id: $buildsId
            ) @include(if: $withBuilds) {
              records {
                id
                status
                modifiedDateTime
                manifest
              }
            }
          }
        }
      }
    `;

    const state = getState();
    const config$$1 = getConfig(state);
    const { apiRoot, graphQLEndpoint } = config$$1;
    const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;

    try {
      const response = await fetchGraphQLApi({
        endpoint: graphQLUrl,
        query,
        extraHeaders: getExtraHeaders$1(state),
        variables: {
          name: searchQuery,
          offset,
          limit,
          owned,
          filter: _pickBy(filters, (filter = []) => filter && !!filter.length),
          buildsId: builds.id,
          buildsStatusStr: builds.status,
          buildsStatus: builds.buildStatus,
          buildsOffset: builds.offset,
          buildsLimit: builds.limit,
          withBuilds: !_isEmpty(builds)
        },
        token: selectSessionToken(getState()) || selectOAuthToken(getState())
      });

      if (!_isEmpty(response.errors) && _isEmpty(response.data.engines)) {
        throw response.errors;
      }

      const results = _get(response, 'data.engines.records');

      dispatch({
        type: FETCH_ENGINES_SUCCESS,
        payload: { results },
        meta: { searchQuery, filters, id }
      });
    } catch (err) {
      dispatch({
        type: FETCH_ENGINES_FAILURE,
        payload: err,
        meta: { filters }
      });
    }
  };
}

const fetchEngineCategories = ({ offset, limit } = {}, searchQuery, type) => async (dispatch, getState) => {
  const query = `
      ${engineCategoryFieldsFragment}
      query EngineCategories(
        $name: String = ""
        $offset: Int
        $limit: Int
        $type: String
      ) {
        results: engineCategories(
          name: $name
          offset: $offset
          limit: $limit
          type: $type
        ) {
          records {
            ...engineCategoryFields
          }
        }
      }
    `;

  return await callGraphQLApi({
    actionTypes: [FETCH_ENGINE_CATEGORIES, FETCH_ENGINE_CATEGORIES_SUCCESS, FETCH_ENGINE_CATEGORIES_FAILURE],
    query,
    variables: {
      name: searchQuery,
      offset,
      limit,
      type
    },
    dispatch,
    getState
  });
};

function getEngines(state) {
  return local$4(state).enginesById;
}

function getEngine(state, engineId) {
  return local$4(state).enginesById[engineId];
}

function isFetchingEngines(state) {
  return local$4(state).isFetching;
}

function failedToFetchEngines(state) {
  return local$4(state).fetchingFailed;
}

function getEngineCategories(state) {
  return local$4(state).engineCategories;
}

function isFetchingEngineCategories(state) {
  return local$4(state).isFetchingCategories;
}

function failedToFetchEngineCategories(state) {
  return local$4(state).fetchingCategoriesFailed;
}

const engineFieldsFragment = `
  fragment engineFields on Engine {
    id
    name
    description
    logoPath
    iconPath
    rating
    price
    deploymentModel
    ownerOrganization {
      name
    }
    category {
      iconClass
      name
      color
    }
  }
`;

const engineCategoryFieldsFragment = `
  fragment engineCategoryFields on EngineCategory{
    id
    name
    description
    categoryType
    type {
      name
      description
    }
    iconClass
    color
  }
`;



var engineModule = Object.freeze({
	namespace: namespace$4,
	FETCH_ENGINES: FETCH_ENGINES,
	FETCH_ENGINES_SUCCESS: FETCH_ENGINES_SUCCESS,
	FETCH_ENGINES_FAILURE: FETCH_ENGINES_FAILURE,
	FETCH_ENGINE_CATEGORIES: FETCH_ENGINE_CATEGORIES,
	FETCH_ENGINE_CATEGORIES_SUCCESS: FETCH_ENGINE_CATEGORIES_SUCCESS,
	FETCH_ENGINE_CATEGORIES_FAILURE: FETCH_ENGINE_CATEGORIES_FAILURE,
	default: engineReducer,
	fetchEngines: fetchEngines,
	fetchEngineCategories: fetchEngineCategories,
	getEngines: getEngines,
	getEngine: getEngine,
	isFetchingEngines: isFetchingEngines,
	failedToFetchEngines: failedToFetchEngines,
	getEngineCategories: getEngineCategories,
	isFetchingEngineCategories: isFetchingEngineCategories,
	failedToFetchEngineCategories: failedToFetchEngineCategories
});

const namespace$5 = 'confirmation';

const CONFIRM = 'vtn/confirmation/CONFIRM';
const SHOW_CONFIRMATION = 'vtn/confirmation/SHOW_CONFIRMATION';
const APPROVE_CONFIRM_ACTION = 'vtn/confirmation/APPROVE_CONFIRM_ACTION';
const CANCEL_CONFIRM_ACTION = 'vtn/confirmation/CANCEL_CONFIRM_ACTION';

const reducer$4 = createReducer({ confirmations: {} }, {
  [SHOW_CONFIRMATION](state, action) {
    return _extends({}, state, {
      confirmations: _extends({}, state.confirmations, {
        [action.meta.id]: action.payload
      })
    });
  },
  // close matching dialog on approve/cancel
  [APPROVE_CONFIRM_ACTION](state, action) {
    return _extends({}, state, {
      confirmations: _omit(state.confirmations, action.meta.id)
    });
  },
  [CANCEL_CONFIRM_ACTION](state, action) {
    return _extends({}, state, {
      confirmations: _omit(state.confirmations, action.meta.id)
    });
  }
});

function local$5(state) {
  return state[namespace$5];
}

const withConfirmation = (actionCreator, configOrConfigFn) => (...args) => {
  const {
    message = 'fixme',
    confirmButtonLabel = 'Confirm',
    cancelButtonLabel = 'Cancel'
  } = _isFunction(configOrConfigFn) ? configOrConfigFn(...args) : configOrConfigFn || {};

  const wrappedAction = actionCreator(...args);

  return {
    type: CONFIRM,
    meta: {
      id: guid()
    },
    payload: {
      wrappedAction,
      message,
      confirmButtonLabel,
      cancelButtonLabel
    }
  };
};

const getConfirmations = state => local$5(state).confirmations;

const approveConfirmAction = id => ({
  type: APPROVE_CONFIRM_ACTION,
  meta: { id }
});

const cancelConfirmAction = id => ({
  type: CANCEL_CONFIRM_ACTION,
  meta: { id }
});

// called by saga only
const _showConfirmationDialog = (_ref) => {
  let { id } = _ref,
      kwargs = objectWithoutProperties(_ref, ['id']);
  return {
    type: SHOW_CONFIRMATION,
    payload: kwargs,
    meta: { id }
  };
};


var confirmationModule = Object.freeze({
	namespace: namespace$5,
	CONFIRM: CONFIRM,
	SHOW_CONFIRMATION: SHOW_CONFIRMATION,
	APPROVE_CONFIRM_ACTION: APPROVE_CONFIRM_ACTION,
	CANCEL_CONFIRM_ACTION: CANCEL_CONFIRM_ACTION,
	default: reducer$4,
	withConfirmation: withConfirmation,
	getConfirmations: getConfirmations,
	approveConfirmAction: approveConfirmAction,
	cancelConfirmAction: cancelConfirmAction,
	_showConfirmationDialog: _showConfirmationDialog
});

function* handleConfirmAction(_ref) {
  let {
    payload: { wrappedAction },
    meta: { id }
  } = _ref,
      kwargs = objectWithoutProperties(_ref.payload, ['wrappedAction']);

  yield put(_showConfirmationDialog(_extends({}, kwargs, {
    id
  })));

  // confirmationDialog view either dispatches
  // APPROVE_CONFIRM_ACTION or CANCEL_CONFIRM_ACTION
  // from user click

  const { confirm } = yield race({
    confirm: take(action => action.type === APPROVE_CONFIRM_ACTION && action.meta.id === id),

    cancel: take(action => action.type === CANCEL_CONFIRM_ACTION && action.meta.id === id)
  });

  if (confirm) {
    yield put(wrappedAction);
  }
}

function* watchConfirmAction() {
  yield takeEvery(CONFIRM, handleConfirmAction);
}

function* root$1() {
  yield all([fork(watchConfirmAction)]);
}

const getExtraHeaders = state => {
  let headers = {};
  const applicationId = selectApplicationId(state);
  const userId = selectUserId(state);
  if (applicationId) {
    headers['x-veritone-application'] = applicationId;
  }
  if (userId) {
    headers['x-veritone-user'] = userId;
  }
  return headers;
};

const uiState = _extends({
  reducer: reducer$1
}, uiStateModule);

const user = _extends({
  reducer: reducer$3
}, userModule, userConstants);

const config = _extends({
  reducer: reducer$2
}, configModule);

const auth = _extends({
  reducer: reducer
}, authModule, authConstants, {
  authRootSaga: root
});

const engine = _extends({
  reducer: engineReducer
}, engineModule);

const confirmation = _extends({
  reducer: reducer$4
}, confirmationModule, {
  confirmationRootSaga: root$1
});

const getExtraHeaders$1 = getExtraHeaders;



var index = Object.freeze({
	uiState: uiState,
	user: user,
	config: config,
	auth: auth,
	engine: engine,
	confirmation: confirmation,
	getExtraHeaders: getExtraHeaders$1
});

function commonHeaders(state) {
  const OAuthToken = selectOAuthToken(state);
  const sessionToken = selectSessionToken(state);
  const extraHeaders = getExtraHeaders$1(state) || {};

  let headers = _extends({
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }, extraHeaders);

  if (OAuthToken || sessionToken) {
    headers.Authorization = `Bearer ${OAuthToken || sessionToken}`;
  }

  return headers;
}

function getCredentialsMode() {
  return 'include';
}

function fetchGraphQLApi({
  endpoint = 'https://api.veritone.com/v3/graphql',
  extraHeaders = {},
  query,
  variables,
  operationName,
  token
}) {
  return fetch(endpoint, {
    method: 'post',
    body: JSON.stringify({
      query,
      variables,
      operationName
    }),
    headers: _extends({
      Authorization: token ? `Bearer ${token}` : null,
      'Content-Type': 'application/json'
    }, extraHeaders),
    credentials: getCredentialsMode()
  }).then(r => r.json());
}



var index$1 = Object.freeze({
	paginateModule: paginate$1,
	paginate: paginate,
	fetchGraphQLApi: fetchGraphQLApi,
	callGraphQLApi: callGraphQLApi,
	promiseMiddleware: promiseMiddleware$1,
	handleApiCall: handleApiCall,
	fetchingStatus: fetchingStatus,
	createReducer: createReducer,
	reduceReducers: reduceReducers
});

var _class;
var _temp;
var _class2;
var _temp2;

/* eslint-disable */
// copied from https://github.com/threepointone/react-redux-saga to fix react16
// compatibility.

// top level component
let Sagas = (_temp = _class = class Sagas extends Component {

  getChildContext() {
    return {
      sagas: this.props.middleware
    };
  }

  render() {
    return Children.only(this.props.children);
  }
}, _class.propTypes = {
  // as returned from redux-saga:createSagaMiddleware
  middleware: PropTypes.func.isRequired
}, _class.childContextTypes = {
  sagas: PropTypes.func.isRequired
}, _temp);

// <Saga saga={generator} {...props}/>
// simple!
let Saga = (_temp2 = _class2 = class Saga extends Component {

  componentDidMount() {
    if (!this.context.sagas) {
      throw new Error('did you forget to include <Sagas/>?');
    }
    this.runningSaga = this.context.sagas.run(this.props.saga, this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // ??
  }

  render() {
    return !this.props.children ? null : Children.only(this.props.children);
  }

  componentWillUnmount() {
    if (this.runningSaga) {
      this.runningSaga.cancel();
      delete this.runningSaga;
    }
  }
}, _class2.propTypes = {
  saga: PropTypes.func.isRequired
}, _class2.contextTypes = {
  sagas: PropTypes.func.isRequired
}, _temp2);

// decorator version
function saga(run) {
  return function (Target) {
    var _class3, _temp3;

    return _temp3 = _class3 = class SagaDecorator extends Component {

      render() {
        return React.createElement(
          Saga,
          _extends({ saga: run }, this.props),
          React.createElement(Target, this.props)
        );
      }
    }, _class3.displayName = 'saga:' + (Target.displayName || Target.name), _temp3;
  };
}



var reactReduxSaga = Object.freeze({
	Sagas: Sagas,
	Saga: Saga,
	saga: saga
});



var index$2 = Object.freeze({
	reactReduxSaga: reactReduxSaga
});

const withUIState = ({
  // specify a key here to use the same key for every instance of this component.
  //   (careful, this won't work if multiple instances exist at the same time!
  //    It's meant for ie. wrapping an entire page container)
  // otherwise, specify it on the component itself <Component uiStateKey="my-key" />
  // if no key is specified, a random one will be assigned for every instance.
  key = null,
  // persist state across unmount/mount? rendered component must be passed a
  // `uiStateKey` prop for persistence to work
  persist = false, // todo: allow config of persistance from a prop
  defaultState = {}
} = {}, connect$$1 = connect) => WrappedComponent => {
  var _dec, _class, _class2, _temp2;

  let WrappedWithUIState = (_dec = connect$$1(() => {
    const randomKey = guid();

    return function mapStateToProps(state, ownProps) {
      const stateKey = ownProps.uiStateKey || key || randomKey;

      return {
        uiStateKey: stateKey,
        uiState: getStateForKey(state, stateKey),
        defaultState: _isFunction(defaultState) ? defaultState(ownProps) : defaultState
      };
    };
  }, {
    setStateForKey,
    clearStateForKey
  }), _dec(_class = (_temp2 = _class2 = class WrappedWithUIState extends React.Component {
    constructor(...args) {
      var _temp;

      return _temp = super(...args), this.setUIState = state => {
        this.props.setStateForKey(this.props.uiStateKey, state);
      }, this.resetUIState = () => {
        this.props.setStateForKey(this.props.uiStateKey, this.props.defaultState);
      }, _temp;
    }

    UNSAFE_componentWillMount() {
      this.isMounting = true;

      if (persist) {
        return this.props.setStateForKey(this.props.uiStateKey, _isEmpty(this.props.uiState) ? this.props.defaultState : this.props.uiState);
      }

      this.resetUIState();
    }

    componentDidMount() {
      this.isMounting = false;
    }

    componentWillUnmount() {
      if (!persist) {
        this.props.clearStateForKey(this.props.uiStateKey);
      }
    }

    render() {
      const restProps = _omit(this.props, ['setStateForKey', 'clearStateForKey', 'defaultState']);

      return React.createElement(WrappedComponent, _extends({}, restProps, {
        uiState:
        // ensure child never sees empty state
        // (it renders once before the intitial store
        // state gets set)
        this.isMounting ? this.props.defaultState : this.props.uiState,
        setUIState: this.setUIState,
        resetUIState: this.resetUIState
      }));
    }
  }, _class2.propTypes = {
    uiStateKey: string.isRequired,
    uiState: objectOf(any),
    setStateForKey: func,
    clearStateForKey: func,
    defaultState: objectOf(any)
  }, _class2.defaultProps = {
    uiState: {},
    setStateForKey: _noop,
    clearStateForKey: _noop
  }, _temp2)) || _class);


  return WrappedWithUIState;
};



var index$3 = Object.freeze({
	withUIState: withUIState
});

export { index$1 as helpers, index as modules, index$2 as util, index$3 as components };



//////////////////
// WEBPACK FOOTER
// ./~/veritone-redux-common/dist/bundle-es.js
// module id = YXPg
// module chunks = 22